import React from 'react'
import Heading from '../../Heading/Heading'
import './GlossaryItems.scss'
import Text from '../../Text/Text'

const GlossaryItem = React.memo(({ word, description }) => (
  <li id={word.toLowerCase().replace(/ /g, '-')}>
    <Heading type="h3" headingSize="h4">
      <a
        className="c-glossary-items__title-link"
        href={`#${word.toLowerCase().replace(/ /g, '-')}`}>
        {word}
      </a>
    </Heading>
    <Text className="c-glossary-items__desc">{description}</Text>
  </li>
))

const GlossaryItems = ({ glossary = [] }) => {
  return (
    <section className="c-glossary-items">
      {Object.keys(glossary).map((letter, index) => (
        <div
          className="c-glossary-items__item"
          id={letter}
          key={`${letter}-${index}`}>
          <Heading
            type="h2"
            headingSize="h1"
            className="c-glossary-items__header">
            {letter}
          </Heading>
          <hr className="c-glossary-items__divider" />
          <ul className="c-glossary-items__links">
            {glossary[letter].map((item) => (
              <GlossaryItem {...item} key={item.word} />
            ))}
          </ul>
        </div>
      ))}
    </section>
  )
}

export default GlossaryItems
